import React from 'react'

import { Button, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import { FormToggle } from 'components/input'
import DescriptionListTable from 'components/table/DescriptionListTable'
import { withForm } from 'decorators/withForm'
import { useCreateCampaign } from 'hooks/useCampaignReview'

type ExchangeCreateProps = {
  back: (...args: any[]) => any
  handleSubmit: (...args: any[]) => any
}

const config = [
  {
    title: 'Above the fold',
    render: () => <FormToggle name="aboveTheFold" />,
  },
]

const ExchangeCreate = ({ back, handleSubmit }: ExchangeCreateProps) => {
  const { id } = useParams()
  const createCampaign = useCreateCampaign()

  const onSubmit = (values: any) => createCampaign.mutate({ id, payload: values })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid size={{ sm: 12 }}>
          <DescriptionListTable config={config} data={{}} titleCellStyle={{ width: '300px' }} />
        </Grid>

        <Grid size={{ sm: 12 }}>
          <Button color="primary" onClick={back}>
            Back
          </Button>

          <Button color="primary" loading={createCampaign.isPending} type="submit" variant="contained">
            Create in exchange
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default withForm({
  form: 'campaignReviewCreate',
})(ExchangeCreate)
